"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExclusionaryOptionsValue = void 0;
function isExclusionaryOptionsValue(options) {
    return 'exclude' in options || 'locked' in options;
}
exports.isExclusionaryOptionsValue = isExclusionaryOptionsValue;
